import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { articleList } from '@/mocks/articles';

export default function ArticleListPage() {
  const webpageSchema = {
    name: '文章中心 - 久久久品质生活',
    description: '久久久文章中心，分享品质生活、产品选购、保养技巧等专业内容，让品质生活更持久。',
    url: 'https://www.jiujiujiu.com/articles',
  };

  return (
    <>
      <ScrollToTop />
      <SchemaOrg type="WebPage" data={webpageSchema} />

      <Navbar />

      <main className="pt-24 md:pt-28">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '文章中心' },
            ]}
          />

          <div className="mb-10 md:mb-12">
            <p className="text-xs font-label tracking-[0.15em] uppercase text-foreground-500 mb-3">文章中心</p>
            <h1 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">品质生活，久久久与您分享</h1>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 pb-16 md:pb-20">
            {articleList.map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300/60 transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-xs px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 font-medium">{article.category}</span>
                    <span className="text-xs text-foreground-400">{article.date}</span>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">{article.excerpt}</p>
                  <div className="mt-4 flex items-center justify-between">
                    <div className="flex items-center gap-2 text-xs text-foreground-400">
                      <i className="ri-time-line"></i>
                      <span>{article.readTime}</span>
                    </div>
                    <div className="flex flex-wrap gap-1.5">
                      {article.tags.slice(0, 2).map((tag) => (
                        <span key={tag} className="text-xs text-foreground-500 px-2 py-0.5 rounded bg-background-100">{tag}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}